import React from "react";
import { Droppable, DragDropContext } from "react-beautiful-dnd";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

export default function JobCategoryList(props) {
  const { onDragEndJobCategory } = props;

  const onDragEnd = (result) => {
    onDragEndJobCategory(result);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="categories-droppable-id">
        {(provided) => (
          <Styled.Container ref={provided.innerRef} {...provided.droppableProps} data-testid="job-category-list">
            {props.children}
            {provided.placeholder} {/* Increases space for dropping */}
          </Styled.Container>
        )}
      </Droppable>
    </DragDropContext>
  );
}

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: JobCategoryList;
    ${[t.my(8), t.rounded.sm]}
    background-color: ${t.dark ? t.color.gray[800] : t.color.gray[100]};
  `;
});
